import type { ReactNode, PropsWithChildren } from "react";
import { InputFieldHint } from "./InputFieldHint";
import { cn } from "@/components/podkit/lib/cn";

type Props = {
    label?: ReactNode;
    id?: string;
    hint?: ReactNode;
    error?: ReactNode;
    className?: string;
    disabled?: boolean;
    "data-testid"?: string;
};
export const InputField = ({
    label,
    id,
    hint,
    error,
    className,
    children,
    disabled = false,
    "data-testid": testId,
}: PropsWithChildren<Props>) => {
    return (
        <div className={cn("flex flex-col gap-1", className)} data-testid={testId}>
            {label && (
                <label
                    className={cn(
                        "text-base font-bold text-content-primary",
                        { "text-gray-400 dark:text-gray-400": disabled },
                        { "text-red-600 dark:text-red-400": error },
                    )}
                    htmlFor={id}
                >
                    {label}
                </label>
            )}
            {children}
            {error && (
                <span data-testid={"input-error"} className="text-sm text-red-500 animate-in fade-in">
                    {error}
                </span>
            )}
            {hint && <InputFieldHint>{hint}</InputFieldHint>}
        </div>
    );
};
